import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex-center"
};
import ActionScreen from "@/modules/action-screens/components/ActionScreen.vue";
import AchievementComponent from "@/modules/archiements/components/Achievement.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'AchievementActionScreen',
  props: {
    achievement: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(ActionScreen, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('achievement_completed')), 1)]),
        default: _withCtx(() => [_createVNode(AchievementComponent, {
          achievement: __props.achievement
        }, null, 8, ["achievement"])]),
        _: 1
      }, 16);
    };
  }
});